// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2XVQF","box":"WorkspacesBox_box__JxJkJ","node":"WorkspacesBox_node__37LG4"};